export const SettingActionTypes = {
  FETCH_SETTINGS_REQUEST: "@@Setting/FETCH_SETTINGS_REQUEST",
  FETCH_SETTINGS_SUCCESS: "@@Setting/FETCH_SETTINGS_SUCCESS",
  FETCH_SETTINGS_FAILURE: "@@Setting/FETCH_SETTINGS_FAILURE",

  UPDATE_SETTING_REQUEST: "@@Setting/UPDATE_SETTING_REQUEST",
  UPDATE_SETTING_SUCCESS: "@@Setting/UPDATE_SETTING_SUCCESS",
  UPDATE_SETTING_FAILURE: "@@Setting/UPDATE_SETTING_FAILURE",
};

